import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { Container, Grid } from '@mui/material';

export default function Loading() {
    return (
        <Grid container sx={{ textAlign: 'center' }}>
            <Container maxWidth="lg">
                <CircularProgress
                    size={90}
                    thickness={3}
                    sx={{
                        margin: {
                            lg: '20% 43%',
                            md: '20% 43%',
                            sm: '20% 38%',
                            xs: '20% 33%',
                        },
                        color: 'primary.main',
                    }}
                />
            </Container>
        </Grid>
    );
}
